import { getBookingProtectionQuote } from 'api/insurance'
import {
  FETCH_BOOKING_PROTECTION_QUOTE,
} from './apiActionConstants'
import { ValueOf } from 'type-fest'
import { API_CALL, SET_BOOKING_PROTECTION_INVALID } from './actionConstants'
import { AppDispatch } from '../store'
import { getBookingProtectionQuoteRequest } from 'checkout/selectors/request/bookingProtection'
import { getBookingProtectionItems } from 'checkout/selectors/view/bookingProtection'
import { addItem, removeItem, setBookingProtectionSelected } from './CheckoutActions'
import { getBookingProtectionQuoteKey } from 'lib/checkout/bookingProtection/utils'

type Actions = Utils.FullActionMap<{}>

export type BookingProtectionActions = ValueOf<Actions>

export function fetchBookingProtectionQuote() {
  return (dispatch: AppDispatch, getState: () => App.State) => {
    const state = getState()

    const quotePayload = getBookingProtectionQuoteRequest(state)

    if (!quotePayload) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_BOOKING_PROTECTION_QUOTE,
      schemaRequestData: quotePayload,
      request: () => getBookingProtectionQuote(quotePayload),
      key: getBookingProtectionQuoteKey(quotePayload),
    })
  }
}

export function setBookingProtectionInvalid(isInvalid: boolean) {
  return {
    type: SET_BOOKING_PROTECTION_INVALID,
    isInvalid,
  }
}

export function removeBookingProtectionItems(resetFormSchema: boolean) {
  return (dispatch: AppDispatch, getState: () => App.State) => {
    const state = getState()

    const bookingProtectionItems = getBookingProtectionItems(state)

    if (bookingProtectionItems.length) {
      bookingProtectionItems.forEach((item: App.Checkout.BookingProtectionItem) => {
        dispatch(removeItem(item.itemId, resetFormSchema))
      })
    }
  }
}

export function addBookingProtectionItem(newItem: App.Checkout.BookingProtectionItem) {
  return (dispatch: AppDispatch) => {
    dispatch(removeBookingProtectionItems(false))
    dispatch(addItem(newItem, true))
    dispatch(setBookingProtectionSelected(true))
    dispatch(setBookingProtectionInvalid(false))
  }
}
